import { Outlet } from 'react-router-dom';

function Autorizar() {
  return <Outlet />;
}

export default Autorizar;
